import { Action } from '@ngrx/store';
import { User, EditUser, NewUser } from '../../user';

export enum UsersActionTypes {
	GetUsers = '[User] Get Users',
	GetUsersSuccess = '[User] Get Users Success',
	GetUsersFailure = '[User] Get Users Failure',
	UpdateUser = '[User] Edit User',
	UpdateUserSuccess = '[User] Edit User Success',
	UpdateUserFailure = '[User] Edit User Failure',
	AddUser = '[User] Add User',
	AddUserSuccess = '[User] Add User Success',
	AddUserFailure = '[User] Add User Failure',
	DeleteUser = '[User] Delete User',
	DeleteUserSuccess = '[User] Delete User Success',
	DeleteUserFailure = '[User] Delete User Failure',
}

export class GetUsers implements Action {
	readonly type = UsersActionTypes.GetUsers;
}

export class GetUsersSuccess implements Action {
	readonly type = UsersActionTypes.GetUsersSuccess;

	constructor(public payload: User[]) {}
}

export class GetUsersFailure implements Action {
	readonly type = UsersActionTypes.GetUsersFailure;

	constructor(public payload: string) {}
}

export class UpdateUser implements Action {
	readonly type = UsersActionTypes.UpdateUser;

	constructor(public payload: EditUser) {}
}

export class UpdateUserSuccess implements Action {
	readonly type = UsersActionTypes.UpdateUserSuccess;

	constructor(public payload: User) {}
}

export class UpdateUserFailure implements Action {
	readonly type = UsersActionTypes.UpdateUserFailure;

	constructor(public payload: string) {}
}

export class AddUser implements Action {
	readonly type = UsersActionTypes.AddUser;

	constructor(public payload: NewUser) {}
}

export class AddUserSuccess implements Action {
	readonly type = UsersActionTypes.AddUserSuccess;

	constructor(public payload: User) {}
}

export class AddUserFailure implements Action {
	readonly type = UsersActionTypes.AddUserFailure;

	constructor(public payload: string) {}
}

export class DeleteUser implements Action {
	readonly type = UsersActionTypes.DeleteUser;

	constructor(public payload: string) {}
}

export class DeleteUserSuccess implements Action {
	readonly type = UsersActionTypes.DeleteUserSuccess;

	constructor(public payload: User) {}
}

export class DeleteUserFailure implements Action {
	readonly type = UsersActionTypes.DeleteUserFailure;

	constructor(public payload: string) {}
}

export type UsersActionsUnion =
	| GetUsers
	| GetUsersSuccess
	| GetUsersFailure
	| UpdateUser
	| UpdateUserSuccess
	| UpdateUserFailure
	| AddUser
	| AddUserSuccess
	| AddUserFailure
	| DeleteUser
	| DeleteUserSuccess
	| DeleteUserFailure;
